import { Badge } from '@/components/ui/badge';
import type { TaskState, PauseReason } from '@agentflow/shared';

const VARIANTS: Record<TaskState, 'default' | 'secondary' | 'destructive' | 'success' | 'warning' | 'info' | 'outline'> = {
  triage: 'info',
  plan: 'info',
  execute: 'info',
  paused: 'warning',
  succeeded: 'success',
  failed: 'destructive',
  cancelled: 'outline',
};

export function StateBadge({
  state,
  pauseReason,
}: {
  state: TaskState;
  pauseReason?: PauseReason | null;
}): JSX.Element {
  const label = state === 'paused' && pauseReason ? `paused · ${pauseReason}` : state;
  return <Badge variant={VARIANTS[state]}>{label}</Badge>;
}
